import { palette } from './palette';
import { fonts } from './fonts';

export const toolbox = {
    palette,
    fonts,
};
